import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  showText?: boolean;
  size?: "sm" | "md" | "lg";
}

export function Logo({ className, showText = true, size = "md" }: LogoProps) {
  const sizes = {
    sm: { icon: 28, text: "text-lg" },
    md: { icon: 36, text: "text-xl" },
    lg: { icon: 48, text: "text-2xl" },
  };

  const { icon, text } = sizes[size];

  return (
    <div className={cn("flex items-center gap-2", className)}>
      {/* SVG Logo - Stylized O with growth chart and AI sparkle */}
      <svg
        width={icon}
        height={icon}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
      >
        {/* Background circle (stylized O) */}
        <circle
          cx="24"
          cy="24"
          r="20"
          stroke="hsl(var(--primary))"
          strokeWidth="3"
          fill="none"
        />
        
        {/* Growth chart inside the O */}
        <path
          d="M14 32 L20 26 L26 28 L34 18"
          stroke="hsl(var(--primary))"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        
        {/* Arrow head for growth */}
        <path
          d="M30 18 L34 18 L34 22"
          stroke="hsl(var(--primary))"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        
        {/* AI Sparkle - top right */}
        <g transform="translate(36, 8)">
          <path
            d="M4 0 L4.5 3 L4 6 L3.5 3 Z"
            fill="hsl(var(--primary))"
          />
          <path
            d="M1 3 L4 3.5 L7 3 L4 2.5 Z"
            fill="hsl(var(--primary))"
          />
        </g>
        
        {/* Small sparkle - accent */}
        <circle
          cx="38"
          cy="12"
          r="1"
          fill="hsl(var(--primary))"
        />
      </svg>

      {showText && (
        <span className={cn("font-bold text-foreground", text)}>
          Opti<span className="text-primary">RO</span>
          <span className="text-muted-foreground font-normal">.dev</span>
        </span>
      )}
    </div>
  );
}
